import Bar from '../../../../components/elements/Bar';
import { Pencil } from 'lucide-react';
import List from '../../../../components/elements/List';
import { usePermission } from '../../../../hooks/usePermission';
import ApprovalItemActions from '../../../approval/components/ApprovalItemActions';

const TechnicalReportItemView = ({ data, onEdit }) => {
  const { isEditable } = usePermission();
  const prepareData = () => {
    if (!data) return [];
    return [
      { name: 'Název', value: data.title },
      { name: 'Popis', value: data.description },
    ];
  };

  return (
    <div>
      <Bar
        text="Detail"
        content={
          isEditable
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  onClick={onEdit}
                  data-testid="tech-report-item-view-edit-btn"
                />,
              ]
            : []
        }
      />
      <ApprovalItemActions
        objectType="technicalreportitem"
        objectId={data?.id}
        status={data?.status}
      />
      <List data={prepareData()} />
      <div className="mb-px">
        <Bar text="Biblio" />
        <List
          data={(data?.biblios || []).map((biblio) => ({
            name: biblio.title,
          }))}
        />
      </div>
    </div>
  );
};

export default TechnicalReportItemView;
